import { useContext } from 'react';
import { BreakpointContext, BreakpointContextValues } from '../components/Breakpoint/BreakpointContext';

export function useBreakpoints(): BreakpointContextValues {
    return useContext(BreakpointContext);
}
